export default __webpack_public_path__ + "static/media/image3.f2668a8a.png";